import axios from 'axios';
//window.base='192.168.8.104:8080';
window.base='';
axios.defaults.baseURL = window.base;

import common from './modules/common'
import login from './modules/login'
import device from './modules/device'
import poe from './modules/poe'
import security from './modules/security'
import logs from './modules/logs'
import accessTools from './modules/accessTools'
import mirroring from './modules/mirroring'
import networks from './modules/networks'
import firmware from './modules/firmware'
import license from './modules/license'
import neighbor from './modules/neighbor'
import multicast from './modules/multicast'
import statistics from './modules/statistics'
import configuration from './modules/configuration'

export default {
  common,
  login,
  device,
	poe,
  security,
	logs,
  accessTools,
  mirroring,
  networks,
  firmware,
  license,
  neighbor,
  multicast,
  statistics,
  configuration
}

